import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchThemes = createAsyncThunk(
    'themes/fetchThemes',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/themes`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)
export const fetchActiveTheme = createAsyncThunk(
    'themes/fetchActiveTheme',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/active-theme`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

export const activateTheme = createAsyncThunk(
    'themes/activateTheme',
    async (themeSlug) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/active-theme`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: {slug: themeSlug},
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

export const restoreTheme = createAsyncThunk(
    'themes/restoreTheme',
    async (slug) => {
        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/themes`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
                "X-WP-Nonce": `${appLocalizer.nonce}`
            },
            data: {slug}
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)